
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';
import { Button }from '@cmsgov/design-system';


// Components

import ErrorMessage from '../../alerts/ErrorMessage';


const UploadModalErrorMessage = props => {
    const {
        backEndError,
        isAnyError,
        parentActions: {
            toggleBackEndErrorVisibility,
            toggleSameUploadVisibility,
            toggleSizeExceedingVisibility,
        },
        primaryTopAnchor,
        sameUploadError,
        sizeExceedingError,
        sizeLimit
    } = props;

    const {
        sameUploadFileName,
        continueAction,
        closeAction
    } = useMemo(
        () => sameUploadError ? sameUploadError : {},
        [ sameUploadError ]
    );

    if(!isAnyError) {
        return null;
    }

    const handleCloseBackEndErrorClick = () => {
        toggleBackEndErrorVisibility(null);
        primaryTopAnchor.current.focus();
    };

    const handleCloseSizeExceedingClick = () => {
        toggleSizeExceedingVisibility(sizeExceedingShown => !sizeExceedingShown);
        primaryTopAnchor.current.focus();
    };

    const handleSameUploadErrorClick = () => {
        toggleSameUploadVisibility(null);
        primaryTopAnchor.current.focus();
        closeAction();
    };

    let enhancedProps = {};

    switch(true) {
        case sizeExceedingError:
            enhancedProps = {
                ...props,
                errorMessage: 'modals.file_size_exceeding_warning',
                id: 'exceed_size',
                errorMessageReplacements: { sizeLimit },
                parentAction: {
                    closeError: handleCloseSizeExceedingClick
                }
            };
            break;
        case !!backEndError:
            enhancedProps = {
                ...props,
                errorMessage: 'modals.request_error.cannot_be_handled',
                id: 'backend_error',
                errorMessageReplacements: { message: backEndError },
                parentAction: {
                    closeError: handleCloseBackEndErrorClick
                }
            };
            break;
        case !!sameUploadError:
            enhancedProps = {
                ...props,
                errorMessage: 'modals.same_upload_warning',
                id: 'same_upload_error',
                errorMessageReplacements: { documentName: sameUploadFileName },
                extraAction: (
                    <Button
                        className = 'usa-button usa-button--primary gi-button gi-button__secondary'
                        onClick = { continueAction }
                    >
                        <FormattedMessage id = 'button.proceed'/>
                    </Button>
                ),
                parentAction: {
                    closeError: handleSameUploadErrorClick
                }
            };
    }

    return (
        <ErrorMessage { ...{ ...enhancedProps } }/>
    );
};

export default UploadModalErrorMessage;